import { GeographyFocus, InvestorRole } from "./ImportedInvestorEntry";

export const SearchableInvestorEntryCollection = "searchable-investors";

export type SearchableInvestorEntry = {
  id: string;
  importedInvestorId: string;
  name: string;
  hasEmail: boolean;
  hasPhone: boolean;
  hasLinkedIn: boolean;
  hasTwitter: boolean;
  hasCrunchbase: boolean;
  hasInvestorRole: boolean;
  investorRole: InvestorRole | null;
  stageFocus: string[];
  sectorFocus: string[];
  geographyFocus: GeographyFocus | null;
};
